<template>
  <div :class="{'flex-wrap table-filter-item': label}">
    <div v-if="label" class="flex-align-center table-filter-label">{{ label }}：</div>
    <el-select
      v-model="valueBackup"
      :clearable="clearable"
      :placeholder="placeholder"
      @change="handleChange"
      :multiple="multiple"
      filterable
      :size="size"
    >
      <el-option
        v-for="item in list"
        :key="item.value"
        :label="item.name"
        :value="item.value"
      />
    </el-select>
  </div>
</template>

<script>
import cardStates from '@/enums/cardStates';

export default {
  props: {
    value: {
      type: [String, Number, Array],
      default: '',
    },
    clearable: Boolean,
    multiple: Boolean,
    size: {
      type: String,
      default: 'medium',
    },
    placeholder: {
      type: String,
      default: '请选择课卡状态',
    },
    label: {
      type: String,
      default: '',
    },
    isLocationLimit: Boolean,
    disabled: Boolean,
    hasPrivate: Boolean,
  },
  data: () => ({
    valueBackup: 0,
    list: cardStates,
  }),
  watch: {
    value(value) {
      if (this.multiple) {
        if (JSON.stringify(value) !== JSON.stringify(this.valueBackup)) this.valueBackup = value || [];
      } else {
        if (value !== this.valueBackup) this.valueBackup = +value || '';
      }
    },
    valueBackup(valueBackup) {
      if (this.multiple) {
        if (JSON.stringify(valueBackup) !== JSON.stringify(this.value)) this.$emit('input', valueBackup);
      } else {
        if (valueBackup !== (+this.value || '')) this.$emit('input', +valueBackup || '');
      }
    },
  },
  methods: {
    handleChange(valueBackup) {
      this.$emit('change', valueBackup);
    },
  },
  beforeMount() {
    if (this.multiple) {
      this.valueBackup = this.value || [];
    } else {
      this.valueBackup = +this.value || '';
    }
  },
};
</script>
